import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import {
  Button,
} from '@fluentui/react-components';
import {
  Dismiss12Regular,
} from '@fluentui/react-icons';

export const KeywordTag = ({
  id,
  listRemoveId,
  name,
  onRemove,
}) => {
  const removeTagId = `${listRemoveId}-${id}`;
  const onRemoveTag = useCallback(() => {
    onRemove(id);
  }, [id, onRemove]);

  return (
    <Button
      appearance="primary"
      aria-labelledby={`${listRemoveId} ${removeTagId}`}
      icon={<Dismiss12Regular />}
      iconPosition="after"
      id={removeTagId}
      onClick={onRemoveTag}
      shape="circular"
      size="small"
    >
      {name}
    </Button>
  );
};

KeywordTag.propTypes = {
  id: PropTypes.number.isRequired,
  listRemoveId: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onRemove: PropTypes.func.isRequired,
};
